<template>
  <ElDialog
    class="ad-contract-accepted"
    :title="title"
    :visible="value"
    width="830px"
    @close="close"
  >
    <div v-if="isLoadingContract" class="ad-contract-accepted__loading-wrapper">
      <HollowDotsSpinner
        :animation-duration="1000"
        :dot-size="12"
        :dots-num="3"
        :color="'#95a5a6'"
      />
    </div>
    <AdContractContent v-else :contract="contractTemplate" />

    <div slot="footer" class="ad-contract-accepted__actions">
      <a
        :disabled="isLoadingContract"
        class="link"
        download
        target="_blank"
        :href="contractPDF"
      >
        <i class="el-icon-download" />
        {{ $t('ADVERTISEMENT.CONTRACT.DOWNLOAD') }}
      </a>
      <ElButton type="primary" @click.native.prevent="close">
        {{ $t('ADVERTISEMENT.CONTRACT.CLOSE') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import AdContractContent from './common/AdContractContent';
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';
import { AdContract } from '@/api/api';
import capitalize from '@/utils/capitalize';
import lang from '@/mixins/lang';

export default {
  name: 'AdContract',
  components: {
    AdContractContent,
    HollowDotsSpinner,
  },
  mixins: [lang],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoadingContract: true,
      contract: null,
    };
  },
  computed: {
    title() {
      if (this.contract) {
        return this.$t('ADVERTISEMENT.CONTRACT.ACCEPTED_TITLE', {
          date: this.contract.acceptanceDate,
        });
      }
      return this.$t('ADVERTISEMENT.CONTRACT.TITLE');
    },
    campitalizedLang() {
      return capitalize(this.normalizedLang);
    },
    contractTemplate() {
      return this.contract[`html${this.campitalizedLang}`];
    },
    contractPDF() {
      if (!this.contract) return '#';

      return this.contract[`downloadLink${this.campitalizedLang}`];
    },
  },
  mounted() {
    this.getContract();
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    getContract() {
      this.isLoadingContract = true;
      return AdContract.getContract()
        .then(contract => {
          this.contract = contract;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoadingContract = false;
        });
    },
  },
};
</script>

<style lang="scss">
.ad-contract-accepted {
  &__loading-wrapper {
    display: flex;
    justify-content: center;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
